// extracted by mini-css-extract-plugin
export default {"card":"CartItems_card__qYDfA","buttons":"CartItems_buttons__xzdKL","heading":"CartItems_heading__p4Ah7","items":"CartItems_items__3iLkA"};